import styled from 'styled-components';
import { Utils } from 'billon-ui';

const { Text } = Utils;

export const ErrorLabel = styled(Text)`
  color: ${(props) => props.isErrorActive && props.theme.palette.error};
`;
